import { useEffect, useState } from "react";

/**
 * The rendered width of the element the returned callback ref is attached to,
 * kept current as it resizes. The ref is a callback so that an element which
 * appears after the first render (a chart that starts out empty) is still
 * observed. 0 until it has been measured, and wherever ResizeObserver is missing.
 */
export const useElementWidth = <T extends HTMLElement>() => {
  const [node, setNode] = useState<T | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!node || typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(([entry]) =>
      setWidth(entry.contentRect.width),
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, width] as const;
};
